import ScheduleCard from './schedule/Schedule'
import SymptomCard from './symptom/Symptom'
import VitalCard from './vital/Vital'
import ActivityCard from './activity/Activity'
import ExerciseCard from './exercise/Exercise'
import LifestyleCard from './lifestyle/Lifestyle'
import ArticleCard from './article/Article'
import QuestionnaireCard from './questionnaire/Questionnaire'
import AppointmentCard from './appointment/Appointment'
import ChecklistCard from './checklist/Checklist'
import MedicationCard from './medication/Medication'

import DirectMessageCard from './message/Direct'
import SentMessageCard from './message/Sent'
import ScheduledMessageCard from './message/Scheduled'

import FacesheetCard from './facesheet/Facesheet'
import ChartCard from './chart/Chart'

import SettingsCard from './settings/Settings'

import FileCard from './record/File'
import RecordCard from './record/Record'
import SurveyCard from './record/Survey'

import ProgressCard from './progress/Progress'
import AssessmentCard from './assessment/Assessment'

export default {
	ScheduleCard,
	SymptomCard,
	VitalCard,
	ActivityCard,
	ExerciseCard,
	LifestyleCard,
	ArticleCard,
	QuestionnaireCard,
	AppointmentCard,
	ChecklistCard,
	MedicationCard,

	DirectMessageCard,
	SentMessageCard,
	ScheduledMessageCard,

	FacesheetCard,
	ChartCard,
	SettingsCard,
	FileCard,
	RecordCard,
	SurveyCard,
	ProgressCard,
	AssessmentCard
}
